import React, { useState, useEffect } from "react";
import { func, bool, string } from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import { sendOtp } from "@quintype/bridgekeeper-js";

import { Login } from "../../molecules/forms/login";
import { SignUpLanding } from "../../molecules/forms/sign-up-landing";
import { CreateAnAccount } from "../../molecules/forms/register";
import { OTP } from "../../molecules/forms/otp";
import { ForgotPassword } from "../../molecules/forms/forgot-password";
import { ResetPassword } from "../../molecules/forms/reset-password";
import LoadingIndicatorComponent from "../../atoms/loading-indicator";
import { navigateTo } from "../../../arrow/utils/utils";

import "./account-modal.m.css";

const AccountModal = ({ onClose, isPopup = true, customCallbackUrl, magazine = false }) => {
  const [activeTab, setActiveTab] = useState("landing");
  const [member, setMember] = useState({});
  const [otpToken, setOtpToken] = useState(null);
  const [renderModal, setRenderModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [userInfo, setUserInfo] = useState({
    name: "",
    email: "",
    password: "",
  });

  const trackSignupError = (err) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_signup_error",
        event_action: "password_submit",
        error_message: err,
      });
    }
  };

  useEffect(() => {
    setRenderModal(true);
  }, []);

  const otpHandler = (member, otpDetails) => {
    setMember(member);
    setOtpToken(otpDetails["email-token"]);
    setActiveTab("otp");
  };

  const onSuccess = async (member) => {
    try {
      const data = { email: member.email, 'always-send': true };

      const otpDetails = await sendOtp(data);
      otpHandler(member, otpDetails);
    } catch (err) {
      trackSignupError(err);
      console.log(err);
    }
  };

  if (!renderModal && !isPopup) {
    return null;
  }

  const getScreen = () => {
    switch (activeTab) {
      case "landing":
        return (
          <SignUpLanding
            navigateTo={setActiveTab}
            customCallbackUrl={customCallbackUrl}
            userInfo={userInfo}
            magazine={magazine}
            setUserInfo={setUserInfo}
            setLoading={setLoading}
          />
        );
      case "login":
        return (
          <Login
            onLogin={(member, res) => otpHandler(member, res)}
            setActiveTab={setActiveTab}
            customCallbackUrl={customCallbackUrl}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setLoading={setLoading}
          />
        );
      case "register":
        return (
          <CreateAnAccount
            onSignup={(m) => onSuccess(m)}
            setActiveTab={setActiveTab}
            customCallbackUrl={customCallbackUrl}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setLoading={setLoading}
          />
        );
      case "otp":
        return (
          <OTP
            id={otpToken}
            member={member}
            onSignup={(member) => onSuccess(member)}
            setLoading={setLoading}
            customCallbackUrl={customCallbackUrl}
            setActiveTab={setActiveTab}
          />
        );
      case "reset-password":
        return (
          <ResetPassword member={member} userInfo={userInfo} setActiveTab={setActiveTab} setLoading={setLoading} />
        );
      case "forgot-password":
        return (
          <ForgotPassword
            onClose={onClose}
            setActiveTab={setActiveTab}
            userInfo={userInfo}
            setUserInfo={setUserInfo}
            setLoading={setLoading}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div styleName="account-modal" className="account-modal">
      <div styleName="form-wrapper" className="form-wrapper">
        <div className="forms">{getScreen()}</div>
      </div>
      <LoadingIndicatorComponent loading={loading} />
    </div>
  );
};

AccountModal.propTypes = {
  onClose: func,
  isPopup: bool,
  customCallbackUrl: string,
  magazine: bool,
};

export default AccountModal;
